import Device from '../Device';

const questions = [{
  type: 'fortress-pairing-code',
  name: 'fortressPairingCode',
  model: 'fortressPairingCode',
  label: 'step3FortressPairingCode',
  show: (values, parent) => Boolean(parent.allQuestionsValid),
  active: true,
  mfg: 'fortress',
  validation: 'required',
}];

const addDevice = async (values, context) => null;

const fortress = new Device('fortress', { mfg: 'fortress', questions, addDevice });

export default fortress;
